import React, { Fragment } from 'react';
import { useAppSelector } from 'src/hooks/hooks';
import Loading from '../Loading/Loading';

const LoadingWrapper = () => {
  const { isLoading } = useAppSelector((state) => state.appReducer);
  return <Fragment>{isLoading && <Loading />}</Fragment>;
};

export default LoadingWrapper;
